module.exports = __webpack_public_path__ + "img/mkt-white.f9c2e080.svg";